import {createRouter, createWebHistory} from "vue-router";
import {can} from "../helpers/Permissions";

import Clients from "../components/clients/ClientsList";
import Attorneys from "../components/attorneys/AttorneysList";
import EditExpedient from "../components/expedients/parts/ExpedientDetail";
import Expedients from "../components/expedients/ExpedientsList";
import Lawyers from "../components/lawyers/LawyersList";
import PdfPreview from "../components/pdf/PdfPreview";
import Profile from "../components/profile/Profile";
import Statuses from "../components/statuses/StatusesList";
import TasksList from "../components/tasks/TasksList";
import TemplateDataPage from "../components/templates/TemplateDataPage";
import TemplateEdit from "../components/templates/edition/TemplateEdit";
import BurofaxTemplatePreviewPage from "../components/templates/BurofaxTemplatePreviewPage";
import TemplatePreviewPage from "../components/templates/TemplatePreviewPage";
import TemplatesList from "../components/templates/edition/TemplatesList";
import Users from "../components/users/UsersList";
import Entities from "../components/entities/EntitiesList";
import BurofaxList from "../components/burofax/BurofaxList.vue";

const routes = [
    {
        path: '/expediente/:expedient/plantilla/:template/pdf',
        name: 'pdf.preview',
        component: PdfPreview
    },

    {
        path: '/profile',
        name: 'profile',
        component: Profile
    },
    {
        path: '/usuarios',
        name: 'user.index',
        component: Users
    },
    {
        path: '/clientes',
        name: 'client.index',
        component: Clients
    },
    {
        path: '/entidades',
        name: 'entity.index',
        component: Entities
    },
    {
        path: '/procuradores',
        name: 'attorney.index',
        component: Attorneys
    },
    {
        path: '/letrados',
        name: 'lawyer.index',
        component: Lawyers
    },
    {
        path: '/plantillas',
        name: 'template.index',
        component: TemplatesList,
    },
    {
        path: '/plantilla/:template/editar',
        name: 'template.update',
        component: TemplateEdit
    },
    {
        path: '/estados',
        name: 'status.index',
        props: true,
        component: Statuses
    },
    {
        path: '/expedientes',
        name: 'expedient.index',
        component: Expedients
    },
    {
        path: '/expediente/:expedient',
        name: 'expedient.update',
        props: true,
        component: EditExpedient
    },
    {
        path: '/expediente/:expedient/plantilla/:template/data',
        name: 'expedient.template.data',
        component: TemplateDataPage,
        props: true,
    },
    {
        path: '/expediente/:expedient/plantilla/:template/preview',
        name: 'expedient.template.preview',
        component: TemplatePreviewPage,
        props: true,
    },
    {
        path: '/expediente/:expedient/plantilla/:template/burofax',
        name: 'expedient.template.burofax.preview',
        component: BurofaxTemplatePreviewPage,
        props: true,
    },
    {
        path: '/tareas',
        name: 'task.index',
        component: TasksList
    },
    {
        path: '/burofaxes',
        name: 'burofax.index',
        component: BurofaxList
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        // When login, redirect to 'expedients.index'
        router.push({name: 'expedient.index'});
    } else if (can(to.name) || to.name === 'not_found' || to.name === 'pdf.preview' || to.name.startsWith('test')) {
        next();
    } else {
        router.push({name: 'not_found'});
    }
})

export default router;
